import React from 'react'

const UnderDevelopmentPage = () => {
    return (
        <div className="page-wrapper">
            <div className="content ">

                <div className='justify-content-center d-flex'>

                    <img src="/img/programmer.gif" alt="Under Development" width={300} />

                </div>
                <h2 className='text-center fw-bold'>Under Development</h2>
            </div>
        </div>
    )
}

export default UnderDevelopmentPage